// extracted by mini-css-extract-plugin
export default {"badges":"SelectedSymptoms_badges__jzCTp"};